import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FaSearch, FaFileAlt, FaArrowLeft } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LayoutWrapper from "../../../components/LayoutWrapper";
import HeaderBar from "../../../components/HeaderBar";
import { ThemeContext } from "../../../context/ThemeContext";
import getCurrentSkin from "../../../utils/getCurrentSkin";
import { useNavigate } from "react-router-dom";


const VendorRating = () => {
  const { isDark, skin } = useContext(ThemeContext);
const currentSkin =getCurrentSkin(skin);
   const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
 const navigate = useNavigate();
  const [filterType, setFilterType] = useState("All");
  const [itemCategory, setItemCategory] = useState("");
  const [itemType, setItemType] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");

  const [categoryOptions, setCategoryOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [results, setResults] = useState([]);

  // Fetch dropdown data
  useEffect(() => {
    axios
      .get("https://nissi-india.com/api/getVendorRatingDropdownData")
      .then((res) => {
        console.log("Dropdown api:", res.data);
        setCategoryOptions(res.data.itemCategories || []);
        setTypeOptions(res.data.itemTypes || []);
      })
      .catch(() => toast.error("Failed to fetch dropdown data"));
  }, []);

  // Search items (filter results)
  const handleSearch = () => {
    axios
      .post("https://nissi-india.com/api/vendoerSearchItemCode", {
        branchid: 1,
        itemcategoryid: itemCategory,
        itemtypeid: itemType,
        itemcode: itemCode,
        itemname: itemName,
      })
      .then((res) => {
        console.log("search api:", res.data);
        setResults(res.data || []);
        toast.success("Search complete");
      })
      .catch(() => toast.error("Search failed"));
  };

  // Fetch rating report
  const handleViewReport = () => {
    const itemIds = results.map((item) => item.fld_itemid); // Replace with correct field name if needed
    axios
      .post("https://nissi-india.com/api/getVendorRatingReport", {
        branchid: 1,
        itemids: itemIds,
        ratingType: filterType,
      })
      .then((res) => {
        console.log("report:", res.data);
        setResults(res.data || []);
        toast.success("Report loaded");
      })
      .catch(() => toast.error("Failed to load report"));
  };

  return (
    <LayoutWrapper>
      <HeaderBar title="VENDOR RATING" />
      <ToastContainer />
      <div
        className={`p-6 mt-6 rounded-2xl shadow-xl border ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-black"
            : `bg-white ${currentSkin.glass} text-black`
        }`}
      >
  <div className="flex items-end gap-4">
          <button  
                      className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-4 py-2 rounded transition-colors`}
                    onClick={() => navigate(-1)}
                  >
                      <FaArrowLeft /> Back
                    </button>
                    </div>
        {/* Filter Type */}
        <div className="flex items-center gap-8 mb-6">
          {["All", "Price Wise", "Delivery Wise", "Quality Wise", "Flexibility Wise"].map((type) => (
            <label key={type} className="flex items-center gap-2 text-sm font-medium">
              <input
                type="radio"
                value={type}
                checked={filterType === type}
                onChange={() => setFilterType(type)}
                className="accent-blue-600"
              />
              {type}
            </label>
          ))}
        </div>

        {/* Filters */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <div className="space-y-4">
            <div>
              <label className="block font-semibold">Item Category</label>
              <select
                value={itemCategory}
                onChange={(e) => setItemCategory(e.target.value)}
                className="w-full border border-gray-300 px-3 py-2 rounded"
              >
                <option value="">Select</option>
                {categoryOptions.map((item) => (
                  <option key={item.fld_itemcategoryid} value={item.fld_itemcategoryid}>
                    {item.fld_itemcategory_name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block font-semibold">Item Code</label>
              <input
                value={itemCode}
                onChange={(e) => setItemCode(e.target.value)}
                className="w-full border border-gray-300 px-3 py-2 rounded"
              />
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block font-semibold">Item Type</label>
              <select
                value={itemType}
                onChange={(e) => setItemType(e.target.value)}
                className="w-full border border-gray-300 px-3 py-2 rounded"
              >
                <option value="">Select</option>
                {typeOptions.map((item) => (
                  <option key={item.fld_id} value={item.fld_id}>
                    {item.fld_itemtypename}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block font-semibold">Item Name</label>
              <input
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
                className="w-full border border-gray-300 px-3 py-2 rounded"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-8 mt-4">
          <button
            onClick={handleViewReport}
             className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-6 py-2 rounded transition-colors`}
          >
            <FaFileAlt /> 
          </button>

          <button
            onClick={handleSearch}
             className={`flex items-center gap-2 ${buttonClass} ${hoverClass} text-white px-6 py-2 rounded transition-colors`}
          >
            <FaSearch /> Search
          </button>
        </div>

        {/* Result Table */}
        <div className="mt-10">
          <table className="w-full text-sm border rounded overflow-hidden">
         <thead className={`bg-${baseColor}-${baseShade} text-white`}>
              <tr>
                <th className="p-2 border">#</th>
                <th className="p-2 border">Item Code</th>
                <th className="p-2 border">Item Name</th>
                <th className="p-2 border">Vendor</th>
                <th className="p-2 border">Rating</th>
              </tr>
            </thead>
            <tbody>
              {results.length > 0 ? (
                results.map((item, i) => (
                  <tr key={i} className="border-t">
                    <td className="p-2 border">{i + 1}</td>
                    <td className="p-2 border">{item.fld_itemcode}</td>
                    <td className="p-2 border">{item.fld_itemname}</td>
                    <td className="p-2 border">{item.fld_suppliername}</td>
                    <td className="p-2 border">{item.fld_rating}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="p-4 text-center" colSpan="5">
                    No data to show
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default VendorRating;
